(function($){

    function formIsForDownload(form) {
        return form.data('wordpress') === 'download';
    }

    function getDataForm(token, form) {
        var formData = new FormData( form.get(0));

        if(formIsForDownload(form)) {
            formData.append('action', 'new_ebook_download');
        } else {
            formData.append('action', 'new_newsletter_subscriber');
        }
        formData.append('token', token);

        return formData;
    }

    const showMessage = (className, msg, title, form) => {
        const feedback = form.find('.component-feedback');

        feedback.find('.feedback-title').text(title);
        feedback.find('.feedback-description').text(msg);
        feedback.removeClass('success').removeClass('error').addClass(className).fadeIn();
    };

    const showSuccessMsg = (msg, form) => {
        showMessage('success', msg, 'Sucesso!', form);
    }

    const showErrorMsg = (msg, form) => {
        showMessage('error', msg, 'Erro!', form);
    }

    function initNewsletterForm() {
        const forms = $('.form-newsletter')

        forms.each(function(index, formEl){
            const form = $(formEl);

            initFieldMasks(form);

            form.submit(function(e){
                e.preventDefault();
    
                if(!form.valid()){
                    return false;
                }
    
                grecaptcha.ready(function() {
                    grecaptcha.execute('6LeOUvIUAAAAAIfWVcUvMOsiKK2GY8ko7IHW4W0Q', {action: 'submit'}).then(function(token) {
                        sendData(token, form);
                    });
                });
            });
    
            form.validate({
                rules: {
                    email: {
                        required: true,
                        email: true,
                    },
                },
                errorPlacement: function(error, element) {
                    if (element.attr('name') === 'accept') {
                        error.insertAfter(form.find('#accept_term_label'));
                    } else {
                        error.insertAfter(element);
                    }
                },
            });
        })
    }

    function initFieldMasks(form) {
        const phone = form.find('[name=phone]');

        if(!phone.length){ return; }

          const SPMaskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
          };
          const spOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(SPMaskBehavior.apply({}, arguments), options);
              }
          };

          phone.mask(SPMaskBehavior, spOptions);
    }

    function sendData(token, form) {
        let btnText = $('.btn', form).text();
        $.ajax({
            type: 'post',
            url: '/wp/wp-admin/admin-ajax.php',
            data: getDataForm(token, form),
            dataType: 'json',
            mimeType: 'multipart/form-data',
            cache: false,
            contentType: false,
            processData: false,
            beforeSend: () => {
                $('.btn', form).prop('disabled', true).text('Enviando...');
            },
            success: (result) => {
                if(result.status === '1') {
                    form.get(0).reset();
                    showSuccessMsg(result.msg, form);
                } else {
                    showErrorMsg(result.error, form);
                }
                if(formIsForDownload(form)) {
                    loadDownload(result, form);
                    saveDownloadSucces(result);
                }
            },
            error: console.error,
            complete: () => {
                $('.btn', form).prop('disabled', false).text(btnText);
            },
        });
    }

    function getDownloadCache() {
        let downloadCache = {};
        if(localStorage.downloadCache) {
            downloadCache = JSON.parse(localStorage.downloadCache);
        }
        return downloadCache;
    }

    function updatedDownloadCache(cache) {
        localStorage.downloadCache = JSON.stringify(cache);
    }

    function saveDownloadSucces(result) {
        const downloadCache = getDownloadCache();
        downloadCache[result.post_id] = result;
        updatedDownloadCache(downloadCache);
    }

    function getDownloadCacheByPostId(postId) {
        const downloadCache = getDownloadCache();
        if(downloadCache[postId]) {
            return downloadCache[postId];
        }
        return false;
    }

    function loadDownload(result, form) {
        if(formIsForDownload(form)) {
            form.find('.fields-container').slideUp(function(){
                let downloadedPlayer = ""
                if(result.type === 'audio') {
                    downloadedPlayer = renderAudioHtml(result.watchUrl);
                } else if(result.type === 'video') {
                    downloadedPlayer = renderVideoHtml(result.watchUrl);
                }
                form.find('.download-display').html(downloadedPlayer);
            });
        }
    }

    function renderAudioHtml(audioUrl) {
        return $(`<audio autoplay="autoplay" controls="controls">
                        <source src="${audioUrl}" type="audio/mp3" />
                        Seu navegador não suporta HTML5
        </audio>`);
    }

    function renderVideoHtml(videoUrl) {
        if(videoUrl) {
            return $(`<div class="embed-responsive embed-responsive-16by9">
                <iframe 
                    class="embed-responsive-item"
                    width="560" 
                    height="315" 
                    src="${videoUrl}" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>`);
        }
        return '';
    }
    
    $('document').ready(function(){
        initNewsletterForm();

        $('body').on('click', '[data-micromodal-trigger]', function(e){
            e.preventDefault();
    
            const modalId = $(this).attr('data-micromodal-trigger');

            $('#'+modalId+' [data-micromodal-close]').one('click', function(e) {
                MicroModal.close(modalId);
            })

            MicroModal.show(modalId, {
                awaitCloseAnimation: true,
                onShow: function(modal) {
                    let idParts = modal.id.split("-");
                    const postId = idParts.pop();

                    const cached = getDownloadCacheByPostId(postId);

                    if(cached && cached.type !== 'ebook') {
                        loadDownload(cached, $('#'+modal.id).find('.form-newsletter'));
                    }
                },
                onClose: function(modal, activeElement) {
                    stopVideo(activeElement);
                },
            });
        });
    });

    const stopVideo = function ( element ) {
        var iframe = element.querySelector( 'iframe');
        var video = element.querySelector( 'video' );
        var audio = element.querySelector( 'audio' );
        if ( iframe ) {
            var iframeSrc = iframe.src;
            iframe.src = iframeSrc;
        }
        if ( video ) {
            video.pause();
        }
        if( audio ) {
            audio.pause();
        }
    };
})(jQuery)

